import template from './clients.html';
import controller from './clients.controller';

let clientsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default clientsComponent;
